import React, { useState, useContext, Suspense, lazy, useEffect, useRef, useMemo } from 'react';
import { Outlet, Route, Routes, useLocation, Navigate, useNavigate } from 'react-router-dom';
import PcLayout from '../layout/pc';
import { AppContext } from '@utils/AppContext';
import eventBus from '@utils/eventBus';


import HomemainLayout from "@view/page_v3/Layout"
import AiEdit from "@view/page_v3/AiEdit/aiEdit";
import MyProjectList from "@view/page_v3/MyProject/ProjectListPage";
import MyProjectDetail from "@view/page_v3/MyProject/ProjectDetailPage";
import FavorDetail from '@view/page/PhotoProjectDetail/favoriteIndex'
import PhotoProjectDetail from "@view/page/PhotoProjectDetail";
import PersonalSidebar from "@view/page_v3/PersonalCenter/PersonalSidebar";
import PersonalTransaction from "@view/page_v3/PersonalCenter/PersonalTransaction";
import PersonalOrder from "@view/page_v3/PersonalCenter/PersonalOrder";
import PersonalInformation from "@view/page_v3/PersonalCenter/PersonalInformation";
import MemberManage from "@view/page_v3/PersonalCenter/MemberManage";
import RedemptioncodeList from "@view/page_v3/PersonalCenter/RedemptioncodeList";
import { IMAGE_TYPE } from '@utils/CONST'
import Service from '@view/page/Service';
import HomemainSidebar from '@view/page_v3/components/HomemainSidebar'
import ProjectSidebar from '@view/page_v3/components/ProjectSidebar'
import styles from './pc.module.scss'
import { ProjectContextProvider } from "@view/page_v3/hooks/ProjectContext";

// 批量生产
import BatchProductImages from "@view/page_v3/BatchProductImages"
import BatchProductUpload from "@view/page_v3/BatchProductImages/UploadPage"
import BatchProductConfig from "@view/page_v3/BatchProductImages/ConfigPage"
import BatchProductResults from "@view/page_v3/BatchProductImages/ResultsPage"
import BatchProductSelected from "@view/page_v3/BatchProductImages/SelectedPage"
import RedemptioncodePage from "@view/page_v3/BatchProductImages/components/RedemptioncodePage"
import { BatchImagesContextProvider } from "@view/page_v3/BatchProductImages/BatchImagesContext"

// 引入组件
const Taobao = lazy(() => import('@view/page/tripleLogin/taobao.jsx'))
const WebsiteMaintenance = lazy(() => import('@view/page/websiteMaintenance/websiteMaintenance.jsx'))
const HomePage = lazy(() => import('@view/page/HomePage'))
const HomePageMaster = lazy(() => import('@view/page/HomePage/indexMaster.jsx'))
const HomePageMasterSub = lazy(() => import('@view/page/HomePage/indexMasterSub.jsx'))
const Membership = lazy(() => import('@view/page/MemberShip'))
const ConnectUs = lazy(() => import('@view/page/ConnectUs'))

const Pay = lazy(() => import('@view/Pay'))
const ImageExtraction = lazy(() => import('@view/page/imageExtraction'))
const ImageResize = lazy(() => import('@view/page/imageResize'))

function HomeLayout() {
    return (
        <div className={styles.Home_main}>
            <HomemainSidebar />
            <div style={{ flex: 1, overflow: "hidden" }}>
                <Outlet />
            </div>
        </div>
    )
}

function BatchLayout() {
    const location = useLocation();
    const hideSidebar = location.pathname.includes('/config') ||
        location.pathname.includes('/detail') ||
        location.pathname.includes('/selected') ||
        location.pathname.includes('/upload')

    return (
        <div className={styles.Home_main}>
            {/* {!hideSidebar && <HomemainSidebar />} */}
            <div style={{ flex: 1, overflow: "hidden" }}>
                <Outlet />
            </div>
        </div>
    )
}

function MyProjectLayout() {
    return (
        <div className={styles.Pro_main}>
            <ProjectSidebar />
            <div style={{ flex: 1, overflow: "hidden" }}>
                <Outlet />
            </div>
        </div>
    )
}

function PersonalCenterLayout() {
    return (
        <div className={styles.PersonCenter_main}>
            <PersonalSidebar />
            <div style={{ flex: 1, overflowX: "auto", overflowY: "hidden" }}>
                <Outlet />
            </div>
        </div>
    )
}

export default function PcRoute() {
    const location = useLocation();
    const { globalUser, globalOrgInfo } = useContext(AppContext)
    const navigate = useNavigate()

    useEffect(() => {
        const target = document.getElementById('topView')
        if (target) target.scrollIntoView()

        // 根据路由更新meta标签
        const routeMetaMap = {
            '/': {
                description: 'PSAI智能商拍云工作室是虹软科技旗下的智能商拍在线设计平台，psai是一款简洁好用的电商图片创作生成平台图片，并且拥有海量虚拟模特可选择。在psai，你可训练自己的模特模型。psai是一款平面设计工具、在线平面设计软件及AI设计工具,提供海量模特,场景模板,跨境电商模板,跨境电商banner,电商主图等免费设计素材和模板，可在线智能生成海报,一键换色,一键换装,一键去水印,AI扩图,ai海报生成,ai视频 ,AI商品图,ai模特,画质修复,抠图拼图，3秒完成专业设计！',
                keywords: 'psai,虹软,ai模特,ai换背,ai换装，ai鞋子上脚，ai视频生成，一键抠图,画质高清,一键擦除，美化图片'
            },
            '/home/homemain/model': {
                description: '基于虹软psai强大的图像处理技术，仅需1张素材，即可生成海量模特试穿图；智能AI精准识别，真实自然；提供海量不同肤色年龄身材的虚拟模特，商用无忧',
                keywords: 'AI换装,ai模特,ai模特换装,换脸,换背景'
            },
            '/home/homemain/shoesTryon': {
                description: '基于虹软psai强大的图像处理技术，仅需1张素材，即可生成海量模特鞋子上脚试穿图；智能AI精准识别，真实自然；提供海量不同肤色年龄身材的虚拟模特，商用无忧',
                keywords: 'AI换装，AI鞋子上脚,一键生成模特试穿图，低成本高质量商品图片'
            },
            '/home/homemain/clothes': {
                description: '基于虹软psai强大的图像处理技术，仅需1张素材，即可生成海量模特试穿图；智能AI精准识别，真实自然；提供海量不同肤色年龄身材的虚拟模特，商用无忧',
                keywords: 'AI换装,一键生成模特试穿图，低成本高质量商品图片'
            },
            '/home/homemain/model_video': {
                description: 'AI带货视频生成, ai视频生成,切片视频剪辑, 电商视频生成功能工具,电商短视频制作',
                keywords: 'AI电商视频生成, ai视频生成,切片视频剪辑, 电商视频生成功能工具,电商展示视频制作'
            },
            '/home/aiEdit': {
                description: '简洁易用的在线图片优化工具，拥有智能抠图、魔法擦除、一键擦除、画质升级、智能补光、美化图片、滤镜功能，助你轻松上手快速出图。',
                keywords: 'psai,在线设计,图片编辑,电商图片优化，图片一键生成'
            },
            '/home/image_extraction': {
                description: '为您提供免费的图片背景去除工具。只需几步简单操作，您就可以去除图片背景并获得高质量的透明图像。立即体验我们强大的在线编辑功能',
                keywords: '一键背景去除工具 | psai抠图'
            },
            // 可以继续添加其他路由的meta配置
        };

        const defaultMeta = {
            description: 'PhotoStudio® AI致力于极低成本、极高效率满足商业拍摄需求',
            keywords: 'psai,photostudioai,ai商拍,ai电商图'
        };

        const metaInfo = routeMetaMap[location.pathname] || defaultMeta;

        document.querySelector('meta[name="description"]')?.setAttribute('content', metaInfo.description);
        document.querySelector('meta[name="keywords"]')?.setAttribute('content', metaInfo.keywords)
    }, [location.pathname])

    const cmCount = useMemo(() => { // 违规次数;4次及以上需要封号
        return globalUser?.cmCount || 0
    }, [globalUser])
    const cmReadFlag = useMemo(() => { // 已读标记，0-未读，需要弹窗；1-已读
        return globalUser?.cmReadFlag == 0 ? globalUser?.cmReadFlag : (globalUser?.cmReadFlag || 1)
    }, [globalUser])
    const appealBeforeTime = useMemo(() => { // 申诉期限
        return globalUser?.appealBeforeTime || '--'
    }, [globalUser])

    useEffect(() => {
        if (cmCount == 0 || cmReadFlag == 1) return
        if (cmCount < 4) eventBus.emit('violationWarn', cmCount, appealBeforeTime) // 违规警告
        else eventBus.emit('suspenNotice', cmCount, 1, appealBeforeTime) // 封号提醒
    }, [cmCount, cmReadFlag, appealBeforeTime])


    useEffect(() => {
        //活动弹窗
        eventBus.emit('EVENTPOPUP')

        const pathname = location.pathname;
        if (['/home/homemain/clothes',
            '/home/homemain/model',
            '/home/homemain/background',
            '/home/homemain/shoesTryon',
            '/home/homemain/model_video',
            '/home/homemain/model_video_img',
            '/home/homemain/poseTryon',
            '/home/homemain/grassPlant',
            '/home/homemain/watermarkRemove',
            '/home/homemain/simTryon',
            '/home/homemain/glassesTryon'].includes(pathname)) {
            sessionStorage.setItem('lastRouteClothes', pathname);
        } else if (['/home/homemain/commodity'].includes(pathname)) {
            sessionStorage.setItem('lastRouteCommodity', pathname);
        } else {
            sessionStorage.removeItem('lastRouteClothes');
            sessionStorage.removeItem('lastRouteCommodity');
            sessionStorage.removeItem('imgResizeCache')
        }
    }, [location.pathname]);

    // 切换成企业成员账号退出
    useEffect(() => {
        if (!globalOrgInfo?.current?.role) return
        const pathname = location.pathname;
        if (['/home/personalCenter/personalTransaction',
            '/home/personalCenter/personalOrder',
            '/home/personalCenter/memberManage',
            '/home/personalCenter/personalInformation'].includes(pathname) &&
            globalOrgInfo?.current?.role != 'admin') {
            navigate(`/home/homemain/clothes`)
        }
    }, [location.pathname, globalOrgInfo])


    return (
        <Routes>
            <Route path="/" element={<PcLayout />}>
                <Route path="" element={<HomePage />} />
                <Route path="homePageMaster" element={<HomePageMaster />} />
                <Route path="homePageMasterSub" element={<HomePageMasterSub />} />
                <Route path="membership" element={<Membership />} />
                <Route path="connect_us" element={<ConnectUs />} />
                <Route path="service" element={<Service.HomePage />}></Route>
                <Route path="taobao" element={<Taobao />} />
                {/* <Route path="home/*" element={<Home /> } /> */}
                <Route path="home/"
                    element={<div
                        style={{
                            height: `calc(100% - var(--header-height, 0px) - 60px)`,
                            overflow: 'hidden',
                            position: 'relative'
                        }}
                    ><Outlet /></div>}>
                    <Route path="homemain/*" element={<HomeLayout />}>
                        <Route path="model" element={<HomemainLayout imageType={IMAGE_TYPE.MODEL} key={IMAGE_TYPE.MODEL} />}></Route> {/*换模特*/}
                        <Route path="background" element={<HomemainLayout imageType={IMAGE_TYPE.BACKGROUND} key={IMAGE_TYPE.BACKGROUND} />}></Route> {/*换背景*/}
                        <Route path="clothes" element={<HomemainLayout imageType={IMAGE_TYPE.CLOTHES} key={IMAGE_TYPE.CLOTHES} />}></Route> {/*AI试衣*/}
                        <Route path="shoesTryon" element={<HomemainLayout imageType={IMAGE_TYPE.SHOES} key={IMAGE_TYPE.SHOES} />}></Route> {/*鞋子上脚*/}
                        <Route path="commodity" element={<HomemainLayout imageType={IMAGE_TYPE.COMMODITY} key={IMAGE_TYPE.COMMODITY} />}></Route> {/*商品图*/}
                        <Route path="commodityRecolor" element={<HomemainLayout imageType={IMAGE_TYPE.COMMODITYRECOLOR} key={IMAGE_TYPE.COMMODITYRECOLOR} />}></Route> {/*商品换色*/}
                        <Route path="clothRecolor" element={<HomemainLayout imageType={IMAGE_TYPE.CLOTH_RECOLOR} key={IMAGE_TYPE.CLOTH_RECOLOR} />}></Route> {/*服饰换色*/}
                        <Route path="commodity_video" element={<HomemainLayout imageType={IMAGE_TYPE.COMMODITY_VIDEO} key={IMAGE_TYPE.COMMODITY_VIDEO} />}></Route> {/*商品视频*/}
                        <Route path="model_video" element={<HomemainLayout imageType={IMAGE_TYPE.MODEL_VIDEO} key={IMAGE_TYPE.MODEL_VIDEO} />}></Route> {/*动作模仿*/}
                        <Route path="model_video_img" element={<HomemainLayout imageType={IMAGE_TYPE.IMAGE_TO_VIDEO} key={IMAGE_TYPE.IMAGE_TO_VIDEO} />}></Route> {/*图生视频*/}
                        <Route path="poseTryon" element={<HomemainLayout imageType={IMAGE_TYPE.POSE_TRYON} key={IMAGE_TYPE.POSE_TRYON} />}></Route> {/*姿势裂变*/}
                        <Route path="glassesTryon" element={<HomemainLayout imageType={IMAGE_TYPE.GLASSES_TRYON} key={IMAGE_TYPE.GLASSES_TRYON} />}></Route> {/*眼镜试戴*/}
                        <Route path="simTryon" element={<HomemainLayout imageType={IMAGE_TYPE.SIM_TRYON} key={IMAGE_TYPE.SIM_TRYON} />}></Route> {/*同版型试衣*/}
                        <Route path="fusionWear" element={<HomemainLayout imageType={IMAGE_TYPE.FUSION_WEAR} key={IMAGE_TYPE.FUSION_WEAR} />}></Route> {/*搭配上身*/}
                        <Route path="grassPlant" element={<HomemainLayout imageType={IMAGE_TYPE.GRASS_PLANT} key={IMAGE_TYPE.GRASS_PLANT} />}></Route> {/*种草图*/}
                        <Route path="watermarkRemove" element={<HomemainLayout imageType={IMAGE_TYPE.WATERMARK_REMOVE} key={IMAGE_TYPE.WATERMARK_REMOVE} />}></Route> {/*去水印*/}

                        <Route path="favor_detail" element={<FavorDetail />}></Route>
                        <Route path="PhotoProjectDetail" element={<PhotoProjectDetail key="project" />}></Route>
                        <Route path="*" element={<Navigate replace to="/" />} />
                    </Route>
                    {/* <Route path="personalCenter" element={<PersonalCenter key={'personal'} />}></Route>
                    <Route path="personalCenter/record" element={<PersonalCenter key={'personalRecord'} record />}></Route> */}
                    <Route path="aiedit" element={<AiEdit />}></Route>
                    <Route path="image_extraction" element={<ImageExtraction />}></Route>
                    <Route path="imageResize" element={<ImageResize />}></Route>

                    <Route path="product" element={
                        <BatchImagesContextProvider>
                            <BatchLayout />
                        </BatchImagesContextProvider>
                    }>  {/*企业批量生图*/}
                        <Route path="redemptioncodePage" element={<RedemptioncodePage />}></Route>
                        <Route path="batchImages" element={<BatchProductImages />}></Route>
                        <Route path=":projectType/upload" element={<BatchProductUpload />}></Route>
                        <Route path=":projectId">
                            <Route path="config" element={<BatchProductConfig />}></Route>
                            <Route path="detail" element={<BatchProductResults />}></Route>
                            <Route path="selected" element={<BatchProductSelected />}></Route>
                        </Route>
                    </Route>

                    <Route path="myProject" element={
                        <ProjectContextProvider>
                            <MyProjectLayout />
                        </ProjectContextProvider>
                    }>
                        <Route path="batchImages" element={<BatchProductImages isProCenter={true} />}></Route>
                        <Route path="list" element={<MyProjectList />}></Route>
                        <Route path=":projectId/detail" element={<MyProjectDetail />}></Route>
                    </Route>

                    <Route path="personalCenter" element={<PersonalCenterLayout />}>
                        <Route path="personalTransaction" element={<PersonalTransaction />}></Route>
                        <Route path="personalOrder" element={<PersonalOrder />}></Route>
                        <Route path="personalInformation" element={<PersonalInformation />}></Route>
                        <Route path="memberManage" element={<MemberManage />}></Route>
                        <Route path="redemptioncodeList" element={<RedemptioncodeList />}></Route>
                    </Route>

                    <Route path="service" element={<Service.Layout />}>
                        <Route path=":taskType/upload" element={<Service.UploadPage />}></Route>
                        <Route path=":taskId" element={<Service.TaskLayout />}>
                            <Route path="config" element={<Service.ConfigPage />}></Route>
                            <Route path="detail" element={<Service.DetailPage />}></Route>
                        </Route>
                        <Route path="list" element={<Service.ResultsPage />}></Route>
                    </Route>
                    <Route path="*" element={<Navigate replace to="/" />} />
                </Route>
                <Route path="pay" element={<Pay />} />
            </Route>
        </Routes>
    )
}